import i18n from "i18next";
// Bindings for React: allow components to
// re-render when language changes.
import { initReactI18next } from "react-i18next"
import * as translatUS from './en-us.json';
import * as translatCA from './en-ca.json';
import * as translatGB from './en-gb.json';
import * as translatCZ from './cs-cz.json';
import * as translatDK from './da-dk.json';
import * as translatDE from './de-de.json';
import * as translatES from './es-es.json';
import * as translatFI from './fi-fi.json';
import * as translatFR from './fr-fr.json';
import * as translatIT from './it-it.json';
import * as translatJP from './ja-jp.json';
import * as translatKR from './ko-kr.json';
import * as translatNO from './nb-no.json';
import * as translatNL from './nl-nl.json';
import * as translatPL from './pl-pl.json';
import * as translatRU from './ru-ru.json';
import * as translatSE from './sv-se.json';
import * as translatAT from './de-at.json';
import * as translatIE from './en-eu.json';
import * as translatAU from './en-au.json';
import * as translatSG from './en-sg.json';
import * as translatVN from './vi-vn.json';
import * as translatTW from './zh-tw.json';
import * as translatMX from './es-mx.json';
import * as translatBR from './pt-br.json';
import * as translatHK from './en-hk.json';
import * as translatME from './en-me.json';
import * as translatPH from './en-ph.json';
import * as translatAF from './en-af.json';
import * as translatAP from './en-ap.json';
import * as translatLA from './es-la.json';
import * as translatIN from './en-in.json';
import * as translatIL from './en-il.json';
const locale = window.location.pathname.split('/')[1];
const translateLocale = locale?.split("-")?.[1];
const translations: Record<string, Record<string, string>> = {
    'us': { ...translatUS },
    'au': { ...translatAU },
    'sg': { ...translatSG },
    'ca': { ...translatCA },
    'gb': { ...translatGB },
    'cz': { ...translatCZ },
    'dk': { ...translatDK },
    'de': { ...translatDE },
    'es': { ...translatES },
    'la': { ...translatLA },
    'fi': { ...translatFI },
    'fr': { ...translatFR },
    'eu': { ...translatIE },
    'it': { ...translatIT },
    'jp': { ...translatJP },
    'kr': { ...translatKR },
    'no': { ...translatNO },
    'nl': { ...translatNL },
    'pl': { ...translatPL },
    'ru': { ...translatRU },
    'se': { ...translatSE },
    'at': { ...translatAT },
    'tw': { ...translatTW },
    'vn': { ...translatVN },
    'mx': { ...translatMX },
    'br': { ...translatBR },
    'hk': { ...translatHK },
    'me': { ...translatME },
    'ph': { ...translatPH },
    'af': { ...translatAF },
    'ap': { ...translatAP },
    'in': { ...translatIN },
    'il': { ...translatIL },
};
console.log("translateLocale==>", translateLocale);
i18n
    // Add React bindings as a plugin.
    .use(initReactI18next)
    // Initialize the i18next instance.
    .init({
        // Config options

        // Specifies the default language (translateLocale) used
        // when a user visits our site for the first time.
        // We use English here, but feel free to use
        // whichever translateLocale you want.
        lng: translateLocale,

        // Fallback translateLocale used when a translation is
        // missing in the active translateLocale. Again, use your
        // preferred translateLocale here.
        fallbackLng: "us",

        // Enables useful output in the browser’s
        // dev console.
        debug: true,

        // Normally, we want `escapeValue: true` as it
        // ensures that i18next escapes any code in
        // translation messages, safeguarding against
        // XSS (cross-site scripting) attacks. However,
        // React does this escaping itself, so we turn
        // it off in i18next.
        interpolation: {
            escapeValue: true, //escapeValue: true - i18next escapes special characters, which can corrupt UTF-8 characters like Polish "ó" → "Ã³"
        },

        // Translation messages. Add any languages
        // you want here.
        resources: {
            [translateLocale]: {
                translation: translations[translateLocale] // Use translations[translateLocale] if available, otherwise an empty object
            },
        },
        // en: {
        //     // `translation` is the default namespace.
        //     // More details about namespaces shortly.
        //     translation: {...translatEN},
        // },
        // // Arabic
        // ar: {
        //     translation: {
        //         hello_world: "مرحباً بالعالم!",
        //     },
        // },
    });

export default i18n;